import React from 'react';
import { useCPOContext } from '../../contexts/CPOContext';

const PrincipalesSection = ({ orientacion, materiasPrincipalesAprobadas, handleMateriaChange, puntos, materias }) => {
  const { state: cpoState } = useCPOContext();
  if (!orientacion || !orientacion.materias || !Array.isArray(orientacion.materias.principales)) {
    return null;
  }
  const puntosActuales = (puntos && puntos.orientacionPrincipales) ? puntos.orientacionPrincipales : 0;
  const puntosRequeridos = orientacion.nombre === 'Derecho del Trabajo' ? 16 : 12;

  const isChecked = (materiaId) => {
    const m = materias && materias[materiaId];
    if (m) return Boolean(m.estado === 'CURSADA_APROBADA' || m.notaFinal === -2);
    const cm = cpoState?.materias?.[materiaId];
    return Boolean(cm && cm.estado === 'CURSADA_APROBADA');
  };

  const renderMateriaCard = (materia) => (
    <div key={materia.id} style={{
      backgroundColor: 'var(--bg-secondary)',
      color: 'var(--text-primary)',
      padding: '15px',
      borderRadius: '6px',
      boxShadow: 'var(--shadow-small)',
      marginBottom: '10px',
      border: isChecked(materia.id) ? '2px solid var(--success-color)' : '1px solid var(--border-color)'
    }}>
      <label style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px', 
        cursor: 'pointer',
        width: '100%'
      }}>
        <input
          type="checkbox"
          checked={isChecked(materia.id)}
          onChange={(e) => handleMateriaChange(materia.id, e.target.checked)}
          style={{
            width: '20px',
            height: '20px'
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '500' }}>{materia.nombre}</div>
          <div style={{ fontSize: '0.9em', color: 'var(--text-secondary)' }}>{materia.creditos} puntos</div>
        </div>
        {isChecked(materia.id) && (
          <span style={{
            backgroundColor: 'var(--status-cursada-bg)',
            color: 'var(--success-color)',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '0.85em'
          }}>Aprobada</span>
        )}
      </label>
    </div>
  );

  return (
    <div>
      <div style={{
        backgroundColor: 'var(--bg-hover)',
        color: 'var(--text-primary)',
        padding: '10px 15px',
        borderRadius: '4px',
        marginBottom: '15px',
        border: '1px solid var(--border-color)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Puntos acumulados:</span>
          <span style={{ fontWeight: 'bold' }}>{puntosActuales}/{puntosRequeridos}</span>
        </div>
      </div>
      {orientacion.materias.principales.map(materia => renderMateriaCard(materia))}
    </div>
  );
};

export default PrincipalesSection;
